declare global {
  // eslint-disable-next-line
  interface Window {
    _satellite: Record<string, unknown>;
  }
}

// eslint-disable-next-line
window._satellite = window._satellite || {};

const LANGUAGES = new Map([
  ['fi', 'fi_fi'],
  ['sv', 'sv_se'],
  ['en', 'en_us'],
]);

const getLanguage = (): string => {
  return LANGUAGES.get(document.documentElement.lang.slice(0, 2)) ?? 'fi_fi';
};

interface BasicData {
  name: string;
  group: string;
  channel: string;
  business_group: string;
}

interface PhaseData extends BasicData {
  phase_category: string;
  phase: string;
  language: string;
}

interface ActionData extends BasicData {
  action_name: string;
  action_group: string;
  phase: string;
  language: string;
}

const BasicAnalyticsData: BasicData = {
  name: 'Sijoituskoulu',
  group: 'self-service',
  channel: 'ha',
  business_group: 'bank',
};

export const analyticsActionGroup = {
  CLICK: 'click',
  EXPANDER: 'expander',
} as const;

export const analyticsActionName = {
  START: 'Aloita',
  READ_MORE: 'Lue lisaa',
  BACK_TO_COURSES: 'Palaa kaikki kurssit sivulle TOP',
  COURSE_COMPLETED_BACK: 'Suoritettu Palaa',
  COURSE_COMPLETED_NEXT: 'Suoritettu Jatka seuraavaan',
  TASK_CONTENT: 'Kurssitehtava sisalto',
} as const;

export const analyticsPhaseName = {
  INTRO: 'Esittely',
  COURSES: 'Kurssit',
  1: '1 Miksi sijoittaminen kannattaa',
  2: '2 Sijoittaminen ei ole vaikeaa',
  3: '3 Mihin kaikkiin sijoituskohteisiin voi sijoittaa',
  4: '4 Selvitä taloustilanteesi ja paljonko voisit sijoittaa',
  5: '5 Mikä on sinulle paras tapa sijoittaa',
  6: '6 Näin pääset sijoittamisessa alkuun',
  7: '7 Näin rakennat sijoitussalkun',
  8: '8 Vastuullinen sijoittaminen',
  9: '9 Näin verotus liittyy sijoittamiseen',
  10: '10 Sijoittajan muistilista: vinkit onnistumiseen',
} as const;

export const analyticsPhaseCategory = {
  START: 'start',
  STEP: 'step',
} as const;

const sendAdobeAnalyticsData = (
  analyticsParams: PhaseData | ActionData,
  dataType: 'application_phase' | 'application_action',
): void => {
  try {
    // eslint-disable-next-line
    if (window._satellite) {
      // eslint-disable-next-line
      (window._satellite as { track: (type: string, params: unknown) => void }).track(
        dataType,
        analyticsParams,
      );
    }
  } catch {
    // Do nothing
  }
};

export const sendAnalyticsPhase = (
  phaseCategory: (typeof analyticsPhaseCategory)[keyof typeof analyticsPhaseCategory],
  phaseName: (typeof analyticsPhaseName)[keyof typeof analyticsPhaseName],
): void => {
  const params: PhaseData = {
    ...BasicAnalyticsData,
    phase_category: phaseCategory,
    phase: phaseName,
    language: getLanguage(),
  };
  sendAdobeAnalyticsData(params, 'application_phase');
};

export const sendAnalyticsAction = (
  actionName: string,
  actionGroup: (typeof analyticsActionGroup)[keyof typeof analyticsActionGroup],
  pageName: (typeof analyticsPhaseName)[keyof typeof analyticsPhaseName],
): void => {
  const params: ActionData = {
    ...BasicAnalyticsData,
    action_name: actionName,
    action_group: actionGroup,
    phase: pageName,
    language: getLanguage(),
  };
  sendAdobeAnalyticsData(params, 'application_action');
};

export const courseSelectionActionName = (courseNumber: number): string => {
  return `Kurssin valinta ${courseNumber}`;
};

export const taskActionName = (taskNumber: string): string => {
  return `Kurssitehtava suorite ${taskNumber}`;
};

export const resultActionName = (taskNumber: string): string => {
  return `Kurssitehtava Nayta tulos ${taskNumber}`;
};
